import { Responsible } from './Responsible.model';
import { GroupDivision } from '../shared/enums/GroupDivision';
import { Consultant } from './Consultant.model';
import { ContractType } from '../shared/enums/ContractType';
import { Contract } from './Contract.model';
import { HonorariumType } from '../shared/enums/HonorariumType';
import { ExcellenceCenter } from "./ExcellenceCenter.model";

interface Details {
    bp: {
        name: string
        _id: string
    }
    sapCardCode: string
}

export class ConsultantApproval {
    _id: string;
    name: string;
    fcEmail: string;
    responsible: Responsible = new Responsible();
    hourValue: number;
    kind: ContractType = 0;
    honorarium: HonorariumType = 0;
    contract: Contract;
    companyName: string = '';
    active: Boolean;
    excellenceCenter: ExcellenceCenter;
    supportCenter: ExcellenceCenter;
    details: Details;

    loadToApproval(c: Consultant) {

        this._id = c._id;
        this.name = c.name;
        this.fcEmail = c.fcEmail;
        this.active = c.active;
        this.responsible.loadUser(c.responsible);
        if (c.contract !== undefined) {
            this.hourValue = c.contract.hourValue;
            this.kind = c.contract.kind;
            this.honorarium = c.contract.honorarium;
            this.companyName = String(c.contract.companyName);
        }
        this.contract = c.contract;
        this.excellenceCenter = c.excellenceCenter;
        this.supportCenter = c.supportCenter;
    }

    loadToApprovalsGrid(c: any) {
        this._id = c._id;
        this.name = c.name;
        this.fcEmail = c.fcEmail;
        this.responsible.loadUser(c.responsible);
        this.hourValue = c.hourValue;
        this.kind = c.kind;
        this.honorarium = c.honorarium;
        this.contract = c.contract;
        this.excellenceCenter = c.excellenceCenter;
        this.supportCenter = c.supportCenter;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ConsultantApproval.model.ts